import { FC } from 'react';

import { ImagesApp } from '../../constants/images';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as Style from './styles.tags';

const Released: FC = () => {
  const { translate } = useI18nContext();
  return (
    <Style.Released id="released-tag">
      <img id="released-tag-image" src={ImagesApp.svg.released} alt="Released" />
      <span id="released-tag-text">{translate(['TAGS', 'RELEASED_FOR_CODE'])}</span>
    </Style.Released>
  );
};

export default Released;
